// extracted by mini-css-extract-plugin
module.exports = {"header":"modalheader_header__bzvp_","title":"modalheader_title__3RTa1","closeBtn":"modalheader_closeBtn__18kS2"};